module.exports = __webpack_public_path__ + "cc201a79252ddc9899b8390cacab66b1.png";